import { useCallback, useRef } from "react";

/** Close only the deleted record, even if selection changed during the request. */
export function useCloseDeletedSelection<T, K>(
  selected: T | null,
  key: (item: T) => K,
  onClose: () => void
): (deletedKey: K) => void {
  const current = useRef({ selected, key, onClose });
  current.current = { selected, key, onClose };

  return useCallback((deletedKey: K) => {
    const latest = current.current;
    if (latest.selected && latest.key(latest.selected) === deletedKey) {
      latest.onClose();
    }
  }, []);
}
